module.exports = __webpack_public_path__ + "img/empty-profile.fea0771c.svg";